import { render } from "./DadosPix.vue?vue&type=template&id=7f81168c"
import script from "./DadosPix.vue?vue&type=script&lang=js"
export * from "./DadosPix.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__